export const APP_MODE_CHANGER = 'APP_MODE_CHANGER';
export const LANGUAGE_CHANGER = 'LANGUAGE_CHANGER';
export const SIDEBAR_TOGGLER = 'SIDEBAR_TOGGLER';